<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="terminar()">
        <b-container>
            <b-row>
                <b-col cols="12" class="h3 mb-4">
                    {{ $t('partido.completar_datos') }}
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <FormInput :label="$t('formularios.nombre')" id="nombre" :name="$t('formularios.nombre')" rules="required" v-model="datos_comprador.nombre" />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <FormInput :label="$t('formularios.apellidos')" id="apellidos" :name="$t('formularios.apellidos')" rules="required" v-model="datos_comprador.apellidos" />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <DocumentoTipo
                        v-model="datos_comprador.tipoDocumento"
                        :index="0"
                    />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <DocumentoValor
                        v-model="datos_comprador.dni"
                        :type="datos_comprador.tipoDocumento"
                        :index="0"
                    />
                </b-col>
                <DateInput
                    v-model="datos_comprador.fecha_nacimiento"
                    :label="$t('formularios.nacimiento')"
                    name="fecha_nacimiento"
                    id="fecha_nacimiento"
                    data-cy="fecha_nacimiento"
                    min="1900-01-01"
                    max="2999-12-31"
                    rules="required"
                    :disabled="loading"
                    wrapper-class="col-12 col-md-6 col-lg-4"
                />

                <b-col sm="12" md="6" lg="4">
                    <FormInput :label="$t('formularios.cp')" id="cp" :name="$t('formularios.cp')" rules="required" v-model="datos_comprador.cp" />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <div class="form-group">
                        <label for="nombre">Email</label>
                        <ValidationProvider name="email" rules="required|email" vid="confirmation" mode="passive" v-slot="{ errors }">
                            <input type="" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="email" placeholder="Email" v-model="datos_comprador.email"/>
                            <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <div class="form-group">
                        <label>{{ $t('formularios.confirmar_email') }}</label>
                        <ValidationProvider :name="$t('formularios.confirmar_email')" :rules="'required|confirmed_ci:@confirmation'" mode="passive" v-slot="{ errors }">
                            <input type="" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.confirmar_email')" v-model="datos_comprador.email_confirmation" id="email_confirmation"/>
                            <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <div class="form-group">
                        <label>{{ $t('formularios.telefono') }}</label>
                        <PhoneInput
                            :phone="datos_comprador.telefono ?? null"
                            :desactivar="false"
                            :required="false"
                            @setNumber="(number) => datos_comprador.telefono = number"
                            @validNumber="(valid) => isValidNumber = valid"
                        />
                    </div>
                </b-col>
                <template v-if="fields && fields.length > 0">
                    <div v-for="(field, index) in fields" :key="index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4 col-md-6' : '')">
                        <FieldComponent
                            :field="field"
                            :desactivar="false"
                            v-model="datos_comprador.properties[field.name]"
                        />
                    </div>
                </template>
                <b-col cols="12">
                    <DatosProductosComponent :productos="productos" />
                </b-col>
                <b-col cols="12" class="mt-1 mt-md-2">
                    <Button
                        type="submit"
                        :label="$t('formularios.continuar')"
                        :disabled="loading"
                    />
                    <Button
                        type="button"
                        :label="$t('formularios.atras')"
                        :disabled="loading"
                        custom-class="ml-2"
                        @click="$emit('changeStep', true)"
                    />
                </b-col>
            </b-row>
        </b-container>
    </ValidationObserver>
</template>

<script setup>
    import { ref, onMounted, getCurrentInstance } from 'vue'
    import store from '@/store'
    import { config } from '@/config.js';
    import PhoneInput from '@/components/common/PhoneInput.vue'
    import FieldComponent from '@/components/common/FieldComponent'
    import DatosProductosComponent from '../events/compra/components/productos/DatosProductosComponent.vue'
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue'
    import DocumentoValor from '@/components/common/DocumentoValor.vue'
    import DateInput from '@/modules/ui/DateInput.vue';
    import Button from '@/modules/ui/Button.vue'

    const props = defineProps({
        datos_comprador: {
            type: Object,
            required: true
        },
        jet_id: {
            required: false
        },
        formulario: {
            required: false
        },
        fields: {
            type: Array,
            required: true
        },
        session_id: {
            required: true,
        },
        session_id_carrito: {
            required: true,
        },
        productos: {
            type: Array,
            required: true
        }
    })

    const emit = defineEmits(['update:jet_id', 'update:formulario', 'changeStep'])

    const instance = getCurrentInstance()
    const toast = instance?.proxy.$toast

    const observer = ref(null)
    const loading = ref(false)
    const isValidNumber = ref(false)

    const terminar = async() => {
        const isValid = await observer.value.validate()

        if (isValid && isValidNumber.value) {
            loading.value = true

            const params = {
                filters: {
                    sesion_id: props.session_id,
                    tid: store.getters.getTeatro.hash
                },
                datos_compradores: props.datos_comprador,
                session_id: props.session_id_carrito
            }

            try {
                const res = await store.dispatch(config.getVuexAlias('front.guardar.datos.comprador'), params)
                emit('update:jet_id', res.data.jet_id)
                emit('update:formulario', res.data.formulario)
                emit('changeStep')
                toast.success('Datos guardados correctamente')
            } finally {
                loading.value = false
            }
        }
    }

    onMounted(() => {
        if (props.fields && props.fields.length > 0) {
            props.datos_comprador.properties = {}
            props.fields.forEach(field => {
                props.datos_comprador.properties[field.name] = ''
            })
        }

        if (!props.datos_comprador.tipoDocumento) {
            props.datos_comprador.tipoDocumento = 'DNI'
        }
    })
</script>
